









import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { LoadingStatusType } from "./enums/enums";
import Layout from "./views/Layout.vue";
import IsLoading from "@/components/element/IsLoading.vue";
import AlertComponent from "@/components/element/AlertComponent.vue";
import {
  BroadcastTabChannelMasterTabClose,
  CheckBroadcastIsSupport,
  SetTabChannel,
} from "./broadcastChannel/tabChannel";
import { CheckIndexedDBIsSupport } from "./IndexedDB/tabIndexedDB";
import {
  ClearTabDB,
  ClearTabFromLocalStorage,
  ClearTabFromSessionStorage,
  GetTabIdFromSessionStorage,
  IsMasterTab,
  RemoveTabDB,
} from "./helper/tabHelper";
import { SocketDisconnect } from "./helper/notificationHelper";

const StoreLogIn = namespace("LogIn");

@Component({
  components: {
    Layout,
    IsLoading,
    AlertComponent,
  },
})
export default class App extends Vue {
  private useLayoutPage = false;
  private render = true;

  @StoreLogIn.Getter
  private getLoginLoadingStatus!: LoadingStatusType;

  created() {
    SetTabChannel();
  }

  mounted() {
    window.addEventListener("beforeunload", async () => {
      SocketDisconnect();
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        const tabId = GetTabIdFromSessionStorage();
        const isMasterTab = IsMasterTab();
        if (tabId) {
          ClearTabFromSessionStorage();
          await RemoveTabDB(tabId);
        }
        if (isMasterTab) {
          ClearTabFromLocalStorage();
          BroadcastTabChannelMasterTabClose();
        }
        ClearTabDB();
      }
    });
  }

  destroyed() {
    localStorage.removeItem("lang");
  }
  get isLoginSuccess(): boolean {
    return this.getLoginLoadingStatus === LoadingStatusType.Success;
  }
  @Watch("$localStorage.lang", { immediate: true })
  localStorageLangChanged(newVal: any, oldVal: any) {
    if (localStorage.lang != null) {
      this.$i18n.locale = localStorage.lang;
    }
  }

  @Watch("$route", { immediate: true })
  routeChanged(newVal: any) {
    this.setWebTitle(this.$t(newVal.meta.title));
    if (newVal.name) {
      this.setUseLayoutPage(newVal.name);
    }
  }

  @Watch("$i18n.locale")
  localeChanged(newVal: any) {
    localStorage.setItem("lang", newVal);
    this.render = false;
    this.setWebTitle(this.$t(this.$route.meta.title));
    this.$nextTick(() => {
      this.render = true;
    });
  }

  public setUseLayoutPage(routerName: string) {
    switch (routerName) {
      case "login":
      case "register":
      case "welcome":
      case "selectList":
      case "logout":
      case "statement":
      case "pageNotFound":
      case "sessionExpire":
      case "canNotAccessMerchant":
      case "canNotAccess":
      case "update":
      case "acceptInvitation":
      case "forgotPwd":
      case "resetPwd":
        this.useLayoutPage = false;
        break;

      default:
        this.useLayoutPage = true;
        break;
    }
  }

  public setWebTitle(title: any) {
    if (title) {
      document.title = title;
    }
  }
}
